import { render, staticRenderFns } from "./orderBox.vue?vue&type=template&id=8ae40340&"
import script from "./orderBox.vue?vue&type=script&lang=js&"
export * from "./orderBox.vue?vue&type=script&lang=js&"
import style0 from "./orderBox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports